var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDashboardCalendarIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 171.198,
    height: 162.913,
    viewBox: "0 0 171.198 162.913",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Path_392977",
    x: 0,
    y: 0,
    width: 171.198,
    height: 162.913,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "dashboard-calendar-icon",
    transform: "translate(-1365.663 -1119.929)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_225588",
    "data-name": "Group 225588",
    transform: "translate(1374.663 1120.463)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -9, -0.53)",
    filter: "url(#Path_392977)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_392977-2",
    "data-name": "Path 392977",
    d: "M153.2,66.037V176.921c0,9.4-6.431,17.016-14.363,17.016H14.363C6.431,193.937,0,186.318,0,176.921V66.04c0-9.4,6.431-17.016,14.363-17.016H138.838c7.93,0,14.36,7.619,14.36,17.013",
    transform: "translate(9 -43.02)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_392978",
    "data-name": "Path 392978",
    d: "M153.2,69.731v27.25H0V69.735C0,58.3,6.431,49.024,14.363,49.024H138.838c7.93,0,14.36,9.273,14.36,20.707",
    transform: "translate(0 -43.558)",
    fill: "#0095d9"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_232594",
    "data-name": "Group 232594",
    opacity: 0.05
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_392979",
    "data-name": "Path 392979",
    d: "M165.121,1066.177H154.45a2.445,2.445,0,0,1-2.445-2.445v-10.671a2.446,2.446,0,0,1,2.445-2.445h10.671a2.445,2.445,0,0,1,2.445,2.445v10.671a2.445,2.445,0,0,1-2.445,2.445",
    transform: "translate(-135.057 -933.479)",
    fill: "#999"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_392980",
    "data-name": "Path 392980",
    d: "M397.74,1066.177H387.069a2.445,2.445,0,0,1-2.445-2.445v-10.671a2.446,2.446,0,0,1,2.445-2.445H397.74a2.446,2.446,0,0,1,2.445,2.445v10.671a2.445,2.445,0,0,1-2.445,2.445",
    transform: "translate(-341.74 -933.479)",
    fill: "#999"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_392981",
    "data-name": "Path 392981",
    d: "M630.36,1066.177H619.689a2.445,2.445,0,0,1-2.445-2.445v-10.671a2.445,2.445,0,0,1,2.445-2.445H630.36a2.445,2.445,0,0,1,2.445,2.445v10.671a2.445,2.445,0,0,1-2.445,2.445",
    transform: "translate(-548.426 -933.479)",
    fill: "#999"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_392982",
    "data-name": "Path 392982",
    d: "M862.978,1066.177H852.307a2.446,2.446,0,0,1-2.445-2.445v-10.671a2.446,2.446,0,0,1,2.445-2.445h10.671a2.446,2.446,0,0,1,2.445,2.445v10.671a2.445,2.445,0,0,1-2.445,2.445",
    transform: "translate(-755.107 -933.479)",
    fill: "#999"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_392983",
    "data-name": "Path 392983",
    d: "M1095.6,1066.177h-10.671a2.445,2.445,0,0,1-2.445-2.445v-10.671a2.445,2.445,0,0,1,2.445-2.445H1095.6a2.446,2.446,0,0,1,2.445,2.445v10.671a2.445,2.445,0,0,1-2.445,2.445",
    transform: "translate(-961.791 -933.479)",
    fill: "#999"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_392984",
    "data-name": "Path 392984",
    d: "M165.121,833.621H154.45A2.445,2.445,0,0,1,152,831.176v-10.67a2.445,2.445,0,0,1,2.445-2.445h10.671a2.445,2.445,0,0,1,2.445,2.445v10.67a2.445,2.445,0,0,1-2.445,2.445",
    transform: "translate(-135.057 -726.852)",
    fill: "#999"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_392985",
    "data-name": "Path 392985",
    d: "M397.74,833.621H387.069a2.445,2.445,0,0,1-2.445-2.445v-10.67a2.445,2.445,0,0,1,2.445-2.445H397.74a2.445,2.445,0,0,1,2.445,2.445v10.67a2.445,2.445,0,0,1-2.445,2.445",
    transform: "translate(-341.74 -726.852)",
    fill: "#999"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_392986",
    "data-name": "Path 392986",
    d: "M630.36,833.621H619.689a2.445,2.445,0,0,1-2.445-2.445v-10.67a2.445,2.445,0,0,1,2.445-2.445H630.36a2.445,2.445,0,0,1,2.445,2.445v10.67a2.445,2.445,0,0,1-2.445,2.445",
    transform: "translate(-548.426 -726.852)",
    fill: "#999"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_392987",
    "data-name": "Path 392987",
    d: "M862.978,833.621H852.307a2.445,2.445,0,0,1-2.445-2.445v-10.67a2.445,2.445,0,0,1,2.445-2.445h10.671a2.445,2.445,0,0,1,2.445,2.445v10.67a2.445,2.445,0,0,1-2.445,2.445",
    transform: "translate(-755.107 -726.852)",
    fill: "#999"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_392988",
    "data-name": "Path 392988",
    d: "M1095.6,833.621h-10.671a2.445,2.445,0,0,1-2.445-2.445v-10.67a2.445,2.445,0,0,1,2.445-2.445H1095.6a2.445,2.445,0,0,1,2.445,2.445v10.67a2.445,2.445,0,0,1-2.445,2.445",
    transform: "translate(-961.791 -726.852)",
    fill: "#999"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_392989",
    "data-name": "Path 392989",
    d: "M397.74,601.064H387.069a2.445,2.445,0,0,1-2.445-2.445V587.948a2.445,2.445,0,0,1,2.445-2.445H397.74a2.445,2.445,0,0,1,2.445,2.445v10.671a2.445,2.445,0,0,1-2.445,2.445",
    transform: "translate(-341.74 -520.224)",
    fill: "#999"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_392990",
    "data-name": "Path 392990",
    d: "M630.36,601.064H619.689a2.445,2.445,0,0,1-2.445-2.445V587.948a2.445,2.445,0,0,1,2.445-2.445H630.36a2.445,2.445,0,0,1,2.445,2.445v10.671a2.445,2.445,0,0,1-2.445,2.445",
    transform: "translate(-548.426 -520.224)",
    fill: "#999"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_392991",
    "data-name": "Path 392991",
    d: "M862.978,601.064H852.307a2.445,2.445,0,0,1-2.445-2.445V587.948a2.445,2.445,0,0,1,2.445-2.445h10.671a2.445,2.445,0,0,1,2.445,2.445v10.671a2.445,2.445,0,0,1-2.445,2.445",
    transform: "translate(-755.107 -520.224)",
    fill: "#999"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_392992",
    "data-name": "Path 392992",
    d: "M1095.6,601.064h-10.671a2.445,2.445,0,0,1-2.445-2.445V587.948a2.445,2.445,0,0,1,2.445-2.445H1095.6a2.445,2.445,0,0,1,2.445,2.445v10.671a2.445,2.445,0,0,1-2.445,2.445",
    transform: "translate(-961.791 -520.224)",
    fill: "#999"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_392993",
    "data-name": "Path 392993",
    d: "M250.659,121.953a6.126,6.126,0,1,1-6.126-6.126,6.126,6.126,0,0,1,6.126,6.126",
    transform: "translate(-211.826 -102.913)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_392994",
    "data-name": "Path 392994",
    d: "M269.015,20.845h0a3.054,3.054,0,0,1-3.054-3.054V3.054a3.054,3.054,0,1,1,6.108,0V17.791a3.054,3.054,0,0,1-3.054,3.054",
    transform: "translate(-236.308 0)",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_392995",
    "data-name": "Path 392995",
    d: "M447.5,121.953a6.126,6.126,0,1,1-6.126-6.126,6.126,6.126,0,0,1,6.126,6.126",
    transform: "translate(-386.718 -102.913)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_392996",
    "data-name": "Path 392996",
    d: "M465.853,20.845h0a3.054,3.054,0,0,1-3.054-3.054V3.054a3.054,3.054,0,1,1,6.108,0V17.791a3.054,3.054,0,0,1-3.054,3.054",
    transform: "translate(-411.2 0)",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_392997",
    "data-name": "Path 392997",
    d: "M644.335,121.953a6.126,6.126,0,1,1-6.126-6.126,6.126,6.126,0,0,1,6.126,6.126",
    transform: "translate(-561.61 -102.913)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_392998",
    "data-name": "Path 392998",
    d: "M662.691,20.845h0a3.054,3.054,0,0,1-3.054-3.054V3.054a3.054,3.054,0,1,1,6.108,0V17.791a3.054,3.054,0,0,1-3.054,3.054",
    transform: "translate(-586.092 0)",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_392999",
    "data-name": "Path 392999",
    d: "M841.173,121.953a6.126,6.126,0,1,1-6.126-6.126,6.126,6.126,0,0,1,6.126,6.126",
    transform: "translate(-736.502 -102.913)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_393000",
    "data-name": "Path 393000",
    d: "M859.529,20.845h0a3.054,3.054,0,0,1-3.054-3.054V3.054a3.054,3.054,0,1,1,6.108,0V17.791a3.054,3.054,0,0,1-3.054,3.054",
    transform: "translate(-760.984 0)",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_393001",
    "data-name": "Path 393001",
    d: "M1038.01,121.953a6.126,6.126,0,1,1-6.126-6.126,6.126,6.126,0,0,1,6.126,6.126",
    transform: "translate(-911.393 -102.913)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_393002",
    "data-name": "Path 393002",
    d: "M1056.367,20.845h0a3.054,3.054,0,0,1-3.054-3.054V3.054a3.054,3.054,0,1,1,6.108,0V17.791a3.054,3.054,0,0,1-3.054,3.054",
    transform: "translate(-935.876 0)",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_195313",
    "data-name": "Rectangle 195313",
    width: 153.198,
    height: 150.379,
    transform: "translate(0 0)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("text", {
    id: "Remaining_Days",
    "data-name": "Remaining Days",
    transform: "translate(15.599 44.443)",
    fill: "#fff",
    fontSize: 14,
    fontFamily: "Nunito-ExtraBold, Nunito",
    fontWeight: 800
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "REMAINING DAYS"))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardCalendarIcon);
export default __webpack_public_path__ + "static/media/dashboard-calendar-icon.111573904dbac67cd080df3afabc1489.svg";
export { ForwardRef as ReactComponent };